const animes = [
  {
    id: 1,
    name: "My Teen Romantic Comedy SNAFU",
  },
  {
    id: 2,
    name: "Fullmetal Alchemist: Brotherhood",
  },
  {
    id: 3,
    name: "Hyouka",
  },
  {
    id: 4,
    name: "Hunter × Hunter",
  },
  {
    id: 5,
    name: "My Little Monster",
  },
  {
    id: 6,
    name: "Little Busters!",
  },
  {
    id: 7,
    name: "Just Because!",
  },
  {
    id: 8,
    name: "anohana: The Flower We Saw That Day",
  },
  {
    id: 9,
    name: "Baka and Test - Summon the Beasts",
  },
  {
    id: 10,
    name: "The Ancient Magus' Bride",
  },
  {
    id: 11,
    name: "We Never Learn: BOKUBEN",
  },
  {
    id: 12,
    name: "Rascal Does Not Dream of Bunny Girl Senpai",
  },
  {
    id: 13,
    name: "Gamers!",
  },
  {
    id: 14,
    name: "Cowboy Bebop",
  },
];

export default animes;
